// 用户状态
export enum USER_STATE_E {
    OFF_LINE = 0,                // 离线
    ON_LINE = 1,                 // 在线
    LOCKED = 2,                  // 用户被锁定
    PWD_EXPIRED = 3,             // 密码过期
    PWD_INITIAL = 4,             // 用户密码处于初始化状态，需要修改
    PWD_EXPIRING = 5,            // 密码即将到期
    PWD_MODIFY_MANDATORY = 6,    // 下一次登录必须修改密码
    PWD_NEVER_INVALID = 7        // 密码永不过期
}

// 锁定状态
export enum USER_LOCK_STATUS {
    UNLOCK = 0,   // 未锁定
    LOCK = 1      // 锁定
}

// 内置角色
export enum USER_ROLE_E {
    super_administrator = 1,           // 超级管理员
    administrator = 2,                // 管理员
    security_administrator = 3,        // 安全管理员
    network_administrator = 5,         // 网络管理员
    san_resource_administrator = 6,             // SAN资源管理员
    nas_resource_administrator = 7,    // NAS资源管理员
    data_protection_administrator = 8,  // 数据保护管理员
    backup_administrator = 9,           // 备份管理员
    maintenance_administrator = 10,           // 维护管理员
    empty_role = 11,                     // 空角色，预留
    remote_device_administrator = 12, //  远端设备管理员
    monitor = 13, // 监控管理员
    ndmp_backup_administrator = 14, // NDMP备份管理员
    DataTurbo_administrator = 15, // 系统的DataTurbo管理员(微存储支持)
    Remote_assistance_administrator = 16, // 远程协助管理员
    vStore_administrator = 1024, // 租户管理员
    vStore_protocol_administrator = 1025, // 租户协议管理员
    vStore_data_protection_administrator = 1026, // 租户数据保护管理员
    vStore_ndmp_backup_administrator = 1028, // 租户NDMP备份管理员
    vStore_DataTurbo_administrator = 1029 // 租户DataTurbo管理员
}

// 用户类型
export enum USER_SCOPE_E {
    LOCAL = 0,        // 本地
    LDAP = 1,         // LDAP
    LDAP_GROUP = 2,   // LDAP组
    RADIUS = 8,       //RADIUS用户
    REMOTE = 6,
    SSO = 7
}

// 用户登录方式
export enum LOGIN_MODE_E {
    CLI = 1,
    SFTP = 2,
    DM = 3,
    REST = 4,
    SERIA_PORT = 5,
    INBAND = 6
}

export enum ROLE_SOURCE {
    BuildInRole = 0,
    CustomizedRole = 1
}


/**
 * 角色所属组
 */
export enum UserGroupTpyeE {
    System = 1,
    Vstore = 2
}

/**
 * 登录方式选项
 */
export interface LoginModeOpts {
    label: string;
    value: LOGIN_MODE_E;
    disabled?: boolean;
}

/**
 * 用户菜单灰化状态
 */
export interface UserMenuStatus {
    offlineDisabled: boolean;
    lockDisabled: boolean;
    unlockDisabled: boolean;
    removeDisabled: boolean;
    modifyDisabled: boolean;
    modifyPwdDisabled: boolean;
}

/**
 * 用户登录方式相关信息
 */
export interface UserLoginModeInfo {
    // 是否是自定义角色
    isCustomRole: boolean;
    // 至少要选择的登录方式
    leastLoginMode: LOGIN_MODE_E[];
    // 登录方式选项
    loginModeList: LoginModeOpts[];
}
